<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-btn icon class="mt-n1 mx-n1" v-on="on" @click="showDetails = !showDetails">
        [{{index}}]
      </v-btn>
    </template>
    <v-container v-if="reference.logo || reference.logoTitle">
      <v-row justify="center" v-if="reference.logo">
        <v-img :src="reference.logo" max-width="300"/>
      </v-row>
      <v-row justify="center" v-if="reference.logoTitle">
        <span v-html="reference.logoTitle"></span>
      </v-row>
    </v-container>
    <div v-html="formattedReference" />
    <v-dialog v-model="showDetails">
      <v-card>
        <v-card-actions>
          <h2>Reference</h2>
          <v-spacer/>
          <v-btn
              icon
              @click="showDetails = false"
          >
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container>
            <v-row justify="center" v-if="reference.logo">
              <v-img :src="reference.logo" width="300" max-width="300"/>
            </v-row>
            <v-row justify="center" v-if="reference.logoTitle">
              <span v-html="reference.logoTitle"></span>
            </v-row>
            <v-row>
              <v-col>
                <div v-html="formattedReference" />
              </v-col>
              <v-col cols="1">
                <v-btn
                  icon
                  v-clipboard="() => formattedReference"
                  >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="reference.download" >
              <v-col class="shrink" v-if="reference.icon">
                <v-icon>{{reference.icon}}</v-icon>
              </v-col>
              <v-col class="grow">
                <a :href="reference.download">{{reference.downloadName}}</a>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-tooltip>
</template>

<script>
import formatACS from '@/plugins/citation'

export default {
  name: 'Citation',
  props: [
      'id',
      'references'
  ],
  data: () => ({
    index: 0,
    showDetails: false,
    formattedReference: '',
    reference: {}
  }),
  mounted () {
    this.index = this.references.map(e => e.id).indexOf(this.id) + 1
    const reference = this.references[this.index - 1]
    this.reference = reference
    this.formattedReference = formatACS(reference)
  }
}
</script>

<style scoped>

</style>